import type { ReactElement } from "react"
import type { PriceMolProps } from "@onestore/hel/dist/components/molecules/PriceMol"
import type { PriceProps } from "@ionos-web-design-system/react"
import Price from "@ionos-web-design-system/react/price"
import { usePriceTypeContext } from "~/context/PriceTypeContext"
import type { PriceInfo } from "~/fragments/priceInfo"
import type { StaticPrice } from "~/fragments/staticPrice"
import isEmpty from "~/lib/isEmpty"
import { getAlignmentFromVariant, getSizeFromVariant } from "../DetailedPrice"
import { getDetailedStaticPriceData } from "./helpers/getDetailedStaticPriceData"

export type DetailedStaticPriceProps = {
  variant: PriceMolProps["variant"]
  layoutVariant?: PriceProps["variant"]
  staticPrices: StaticPrice[]
  period: string
  customRenewAdditionalInfo?: string
  bundleData?: {
    hasPromotion: boolean
    priceInfo?: PriceInfo
    hidePeriodText?: boolean
  }
  dataTestId?: PriceMolProps["mainPrice"]["dataTest"]
}

const DetailedStaticPrice = ({
  variant,
  layoutVariant,
  staticPrices,
  period,
  customRenewAdditionalInfo,
  bundleData,
  dataTestId,
}: DetailedStaticPriceProps): ReactElement<DetailedStaticPriceProps> | null => {
  const { currentPriceType } = usePriceTypeContext()

  const priceData = getDetailedStaticPriceData(
    staticPrices,
    period,
    currentPriceType,
    customRenewAdditionalInfo,
    bundleData,
    undefined,
    dataTestId
  )

  if (isEmpty(priceData)) {
    return null
  }

  const { data, hasPromotion } = priceData

  return (
    <Price
      alignment={getAlignmentFromVariant(variant)}
      data={data}
      size={getSizeFromVariant(variant)}
      variant={layoutVariant || "simple"}
      emphasis={hasPromotion}
      className="leading-normal"
      hasNoFixedSizes
      forcePostlineWeight
    />
  )
}

export default DetailedStaticPrice
